import(/* webpackMode: "eager", webpackExports: ["SettingsContent"] */ "/home/runner/work/ark/ark/@apps/web/src/app/[locale]/settings/SettingsContent.tsx");
